import { render, staticRenderFns } from "./exam-result.vue?vue&type=template&id=ff61f90c&scoped=true&"
import script from "./exam-result.vue?vue&type=script&lang=js&"
export * from "./exam-result.vue?vue&type=script&lang=js&"
import style0 from "./exam-result.vue?vue&type=style&index=0&id=ff61f90c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff61f90c",
  null
  
)

export default component.exports